module.exports = __webpack_public_path__ + "static/media/image11.c9070599.JPG";